import { EASAttestation } from '@/types';
import { useEasAttestation } from './useEASAttestation';

const VERIFIED_ACCOUNT_SCHEMA_UIDS = {
  84532: '0x2f34a2ffe5f87b2f45fbc7c784896b768d77261e2f24f77341ae43751c765a69',
  8453: '0xf8b05c79f090979bf4a80270aba232dff11a10d9ca55c4f88de95317970f0de9',
};

const VERIFIED_BUSINESS_ACCOUNT_SCHEMA_UIDS = {
  84532: '0x41e3ff343f55e06d49eea3c2a03f4a5ff62589ea1cc5ed382ebadd86e39c18f2',
  8453: '0xf82663c0eac879bed1e09e3d4598752359a321f51b38ae669728f480abf3f474',
};

type VerifiedAccountReqeust = {
  address: `0x${string}`;
  chainId: number;
};

type VerifiedAccountResponse = {
  attestation: EASAttestation | undefined;
  verified: boolean;
  isRetail: boolean;
  isLoading: boolean;
};

const constructReturnData = (
  attestation: EASAttestation | undefined,
  isRetail: boolean,
  isLoading: boolean,
) => {
  if (!attestation) {
    return {
      attestation: undefined,
      verified: false,
      isRetail: false,
      isLoading: isLoading,
    };
  }

  return {
    attestation: attestation,
    verified: attestation.valid,
    isRetail: isRetail,
    isLoading: isLoading,
  };
};

export const useVerifiedAccount = ({
  address,
  chainId,
}: VerifiedAccountReqeust): VerifiedAccountResponse => {
  const schemaUidVA = VERIFIED_ACCOUNT_SCHEMA_UIDS[
    chainId as keyof typeof VERIFIED_ACCOUNT_SCHEMA_UIDS
  ] as `0x${string}`;
  const SchemaUidVBA = VERIFIED_BUSINESS_ACCOUNT_SCHEMA_UIDS[
    chainId as keyof typeof VERIFIED_ACCOUNT_SCHEMA_UIDS
  ] as `0x${string}`;

  const { attestation: attestationVA, isLoading: isLoadingVA } = useEasAttestation({
    address,
    schemaUid: schemaUidVA,
  });
  const { attestation: attestationVBA, isLoading: isLoadingVBA } = useEasAttestation({
    address,
    schemaUid: SchemaUidVBA,
  });

  return constructReturnData(
    attestationVA?.valid ? attestationVA : attestationVBA,
    attestationVA?.valid ? true : false,
    isLoadingVA || isLoadingVBA,
  );
};
